/*
*###############################################################################
*Module Name                   : ReasonTypesMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Tuesday, September 7th 2021, 10:01:02 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'
import ReasonTypesMasterContent from './ReasonTypesMasterContent'
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from 'framework/widgets/DPPermission'
import * as XLSX from "xlsx";
import DPPrintOption from 'framework/widgets/DPPrintOptions'
//**End Importing required componant files */

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { DeleteReasonTypeDetails, ReasonTypeGetData, SaveReasonTypeDetails } from './ReasonTypeController'
const ReasonTypesMaster = (props) => {

    let history = useHistory();
    //*** User input related states */
    const [reasonCode, SetCode] = useState("");// Set Code
    const [reasonDesc, SetDescription] = useState("")//Set Description
    const [IsActive, SetActive] = useState(true)//Set Active state
    const [transType, SetTransType] = useState([])
    const [disPercentage, SetDisPercentage] = useState(0)
    const [disAmount, SetDisAmount] = useState(0)
    const [disStart, SetDisStart] = useState(0)
    const [disEnd, SetDisEnd] = useState(0)
    const [permission, SetPermission] = useState(false)
    const [rReturn, SetRReturn] = useState(false)
    const [rCancel, SetRCancel] = useState(false)
    const [instruct, SetInstruct] = useState(false)
    const [rDiscount, SetRDiscount] = useState(false)
    const [netDis, SetNetDis] = useState(false)
    const [menuCode, SetMenuCode] = useState("")
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [posOperation, SetPosOperation] = useState(false)
    const [bitSummaryLvl, setBitSummaryLvl] = useState(false)
    const [bitDetailLvl, setBitDetailLvl] = useState(false)
    const [reqTxnRef1 , setReqTxnRef1] = useState(false)
    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')
    const [modal_xlarge, setmodal_xlarge] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [disabledCode, setDisabledCode] = useState(false)
    const [saveEnable, setSaveEnable] = useState(true)
    const [crEnable, setCrEnable] = useState(false)
    const [crBy, setCrBy] = useState("")
    const [mdBy, setMdBy] = useState("")
    const [crDate, setCrDate] = useState("")
    const [mdDate, setMdDate] = useState("")
    const [Reason, setReason] = useState("Created")
    const [editEnable, SetEditEnable] = useState(false)
    //*** End User activity related staes */

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    const [transaction, SetTransaction] = useState([])

    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")
    const [LocationCode, setLocationCode] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code
    const [codeButton, setCodeButton] = useState(true)
    const [searchdisabled, setSearchdisabled] = useState(false)
    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(false)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)
    const [printoptionShow, setprintoptionShow] = useState(false)
    const [valueUpload, setvalueUpload] = useState("")
    const [items, setItems] = useState([]);
    const [Excelitems, setExcelItems] = useState([]);
    const [helpUrl, setHelpUrl] = useState("")
    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode, addtoFavourite
    } = useContext(Context);
    //import from contexts

    var time = process.env.REACT_APP_ALERTTIMEOUT

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    //**Get File Details */
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        setLocationCode(LocationCode)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        if (!responseData.strMenuAccessRight) {
            history.push('/dashboard')
        }

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)
        setHelpUrl(responseData.strHelpUrl)
        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

        function Transaction() {
            var requestOptions = {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${authToken}`
                },
                redirect: 'follow'
            };
            fetch(`${ApiURL}common/TxnType/`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    SetTransaction(result.data)
                    let dt = result.data

                }).catch(error => console.log('error', error));
        }
        Transaction()
    }, [reasonCode])

    // AuditLog
    useEffect(async () => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu =
            menuDetail && menuDetail.menuTag
                ? menuDetail.menuTag
                : history.push("/dashboard")

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
    }, [])



    const readExcel = (file) => {
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);
                setExcelItems(data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            setItems(d);
        });
    };


    //*** Get and Set values when user search code */
    async function getData(searchData) {

        if (searchData == "") return

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Fetching...")

        const result = await ReasonTypeGetData(searchData);

        SetLoadingAlert(false)

        if (result.success == true) {

            SetDescription(result.data.name)
            SetActive(result.data.status)
            SetTransType(result.data.type)
            SetDisPercentage(result.data.dbDiscPer)
            SetDisAmount(result.data.dbDiscAmt)
            SetDisStart(result.data.dbDpFrom)
            SetDisEnd(result.data.dbDpTo)
            SetPermission(result.data.intReqAut)
            SetRReturn(result.data.intReturn)
            SetRCancel(result.data.intCancel)
            SetInstruct(result.data.intInstr)
            SetRDiscount(result.data.intDisc)
            SetNetDis(result.data.intNetper)
            SetPosOperation(result.data.intPosOperation)
            setCrBy(result.data.createdBy)
            setCrDate(result.data.createdDate)
            setMdBy(result.data.modifiedBy)
            setMdDate(result.data.modifiedDate)
            setCrEnable(true)
            setBitSummaryLvl(result.data.bitSummaryLvl)
            setBitDetailLvl(result.data.bitDetailLvl)
            setReqTxnRef1(result.data.bitReqTxnRef1)

            SetAddNew(false)
            setDisabled(true)
            setDisabledCode(true)
            setSaveEnable(false)
            SetDeleteEnable(true)
            setReason("Updated")
            SetEditEnable(true)
            setSearchdisabled(true)

        } else {
            if (nullCode == false) {
                displayAlertMessage('success', "Record Not Found !")
                setDisabledCode(true)
                SetCode("")
            }
        }

    }

    //*** End useEffect */





    function tog_xlarge() {
        setmodal_xlarge(!modal_xlarge)
        removeBodyCss()
    }

    //removebodyCss function
    function removeBodyCss() {
        document.body.classList.add("no_padding")
    }

    function stringToBool(value) {
        value = value.toString().toLowerCase();
        return value === "1" || value === "true"

    }

    //save button function
    const handlesave = async (e) => {
        var ExcelItemsRows = [...Excelitems]
        if (Array.isArray(ExcelItemsRows) && ExcelItemsRows.length) {
            var saveList = []
            ExcelItemsRows.map(async (localState) => {
                if ((localState.Code != null) && (localState.Description != null) && (localState.IsActive != null) || !localState.IsActive) {
                    saveList.push({
                        ReasonTypeCode: localState.Code,
                        ReasonTypeDesc: localState.Description,
                        IsActive: stringToBool(localState.IsActive),
                        intReqAut: localState.intReqAut,
                        intType: localState.intType,
                        intReturn: localState.intReturn,
                        intCancel: localState.intCancel,
                        intInstr: localState.intInstr,
                        intDisc: localState.intDisc,
                        intNetper: localState.intNetper,
                        intPosOperation: localState.intPosOperation,
                        dbDiscPer: localState.intDisc == 1 ? 0 : localState.dbDiscPer,
                        dbDiscAmt: localState.intDisc == 1 ? 0 : localState.dbDiscAmt,
                        dbDpFrom: localState.intDisc == 1 ? 0 : localState.dbDpFrom,
                        dbDpTo: localState.intDisc == 1 ? 0 : localState.dbDpTo,
                    })
                }
            })

            const reasonTypeArray = {
                ReasonTypeList: saveList,
                User: LogUserType,
                MenuCode: menuCode,
                LoggedCompany: LogCompanyCode,
                LoggedLocation: LocationCode,
                Reason: Reason,
                CreateBy: LogUserType,
            }

            //var response = await SaveReasonTypeListDetails(reasonTypeArray);

            if (response.success) {
                displayAlertMessage("success", response.message)

                // var autoCodeRes = await fetchAutoCode(menuCode)
                // setExcelItems([]);
                // setvalueUpload("");

                // if (autoCodeRes.nullCode == false) {
                //     setAutoCode(autoCodeRes.autoCode)

                // } else {
                //     setNullCode(true)
                //     setAutoCode("")
                // }

            } else {
                displayAlertMessage("danger", response.message)
            }
        } else {

            //set autogenerate code to as CODE just for display purpuse
            if (addNew == true && nullCode == false) {
                SetCode(autoCode)
            }

            if (reasonCode == "" && nullCode == true) {
                displayAlertMessage('danger', "Please Enter Code !")
                return;
            }
            if (reasonDesc == "") {
                displayAlertMessage('danger', "Please enter description")
                return;
            }

            if (rDiscount == false) {
                if (disStart > disEnd) {
                    displayAlertMessage('danger', "End Discount must Grater than or Equal to Start Discount")
                    return;
                }
            }

            var ActiveStat = IsActive == "1" ? true : false; //checking active sate
            var Permission = permission == true ? 1 : 0
            var ReturnO = rReturn == true ? 1 : 0
            var Cancel = rCancel == true ? 1 : 0
            var Instruct = instruct == true ? 1 : 0
            var Discount = rDiscount == true ? 1 : 0
            var Net = netDis == true ? 1 : 0
            var Pos = posOperation == true ? 1 : 0

            const selectedTransType = []
            transType.map((item) => {
                selectedTransType.push({
                    "type": item
                })
            })

            const raw = {
                "strReasonTypeCode": addNew == true && nullCode == false ? autoCode : reasonCode,
                "strReasonTypeDesc": reasonDesc,
                "IsActive": ActiveStat,
                "intReqAut": Permission,
                "txnTypes": selectedTransType,
                "intReturn": ReturnO,
                "intCancel": Cancel,
                "intInstr": Instruct,
                "intDisc": Discount,
                "intNetper": Net,
                "intPosOperation": Pos,
                "dbDiscPer": Discount == 1 ? 0 : parseFloat(disPercentage),
                "dbDiscAmt": Discount == 1 ? 0 : parseFloat(disAmount),
                "dbDpFrom": Discount == 1 ? 0 : parseFloat(disStart),
                "dbDpTo": Discount == 1 ? 0 : parseFloat(disEnd),
                "bitSummaryLvl": bitSummaryLvl,
                "bitDetailLvl": bitDetailLvl,
                "bitReqTxnRef1":reqTxnRef1,
                "strMenuCode": menuCode,
                "strLoggedCompany": LogCompanyCode,
                "strLoggedLocation": LocationCode,
                "strReason": Reason,
                "strCreateBy": LogUserType,
                "blAddNew": addNew
            }

            //loading alert show
            SetLoadingAlert(true)
            if (addNew == true) {
                SetLoadingAlerttitle("Saving...")
            } else {
                SetLoadingAlerttitle("Updating...")
            }

            //*** save/update records */
            const result = await SaveReasonTypeDetails(raw);

            SetLoadingAlert(false)

            if (result.success) {
                displayAlertMessage("success", result.data)
                ClearItem()
            } else {
                if (result.data == "Code Already Exsist!") {
                    setCodeButton(false)
                }
                displayAlertMessage("danger", result.data)
            }
        }
    }
    //***save/update end */

    //*** Get user selected row details */
    const GetSelectRow = (e, row, isSelect, rowIndex) => {
        SetCode(row.RC_CODE)
        getData(row.RC_CODE)
        setDisabled(true)
        setDisabledCode(true)
        setSaveEnable(false)
        setmodal_xlarge(!modal_xlarge);
        setCrEnable(true)

    }
    //*** End of getSelectedRow function */

    //edit button function    
    const handleEdit = e => {
        setDisabled(false)
        setDisabledCode(true)
        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
    }

    //new button function
    const handleNew = e => {
        // e.preventDefault()
        ClearItem();
        setShow(false)
        setSaveEnable(true)
        setCrEnable(false)
    }

    //clear fields function    
    const ClearItem = () => {
        SetCode("")
        SetDescription("")
        SetTransType([])
        SetDisPercentage(0)
        SetDisAmount(0)
        SetDisStart(0)
        SetDisEnd(0)
        SetPermission(false)
        SetRReturn(false)
        SetRCancel(false)
        SetInstruct(false)
        SetRDiscount(false)
        SetNetDis(false)
        SetPosOperation(false)
        SetActive(true)
        setDisabledCode(false)
        setDisabled(false)
        setCrEnable(false)
        SetAddNew(true)
        setErrorMsg('')
        SetDeleteEnable(false)
        SetDeleteEnable(false)
        setNullCode(false)
        setSearchdisabled(false)
        SetEditEnable(false)
        setSaveEnable(true)
        setPermissionName("")
        setPermissionPassword("")
        setPermissionNameDisable(false)
        setCodeButton(true)
        setBitSummaryLvl(false)
        setBitDetailLvl(false)
        setReqTxnRef1(false)
        setExcelItems([])
        setTimeout(() => {
            setExcelItems([])
        }, 1)
    }

    //********Delete button function */
    const handleDelete = async () => {

        const rowDelete = {
            "strMenuCode": menuCode,
            "strCode": reasonCode,
            "strLoggedCompany": LogCompanyCode,
            "strLoggedLocation": LocationCode,
            "strReason": Reason,
            "strCreateBy": crBy
        }
        //loading alert show
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Deleting...")

        const result = await DeleteReasonTypeDetails(rowDelete);

        SetLoadingAlert(false)

        if (result.success) {
            displayAlertMessage("success", result.data)
            ClearItem()

        } else {
            displayAlertMessage("danger", result.data)
        }
    }
    //*********Delete button function end */


    // print Function
    async function handlePrint(option) {
        var option = option

        SetLoadingAlert(true)
        SetLoadingAlerttitle("Generating Report...")

        const ReportURL = window.Links.ReportURL
        await fetch(`${ReportURL}api/ReasonType/report/${LogUserType}/${option == "PDF" ? 1 : 0}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
        }).then(Response => Response.json())
            .then(responseData => {

                if (responseData.success == true) {
                    if (option == "PDF") {
                        {
                            const msg = responseData.msg
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
                        }
                    }
                    if (option == "XCEL") {
                        {
                            const msg = responseData.msg
                            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
                        }
                    }

                }
                SetLoadingAlert(false)
            }).catch(error => {
                console.log(error.message)
                SetLoadingAlert(false)
            })
    }

    //CODE AUTO GEN
    const AutoGenerateCode = async () => {
        await fetch(`${ApiURL}common/autocode/${menuCode}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        }).then(Response => Response.json())
            .then(responseData => {
                if (responseData.success == true) {
                    if (responseData.data.length > 0) {
                        SetCode(responseData.data)
                        setAutoCode(responseData.data)
                    } else {
                        setDisabledCode(false)
                    }
                }
            })
    }


    //**Permission Check */
    const permissions = (operation) => {
        const permissiondata = {
            "strUsername": permissionName,
            "strPassword": permissionPassword,
            "strLocation": LocationCode,
            "strMenuCode": menuCode
        }

        clearPermissionInputs()

        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {

                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()
                            } else if (Modify == true) {
                                handlesave()
                            } else {
                                if (operation == "Save" && addNew == true) {
                                    displayAlertMessage('danger', "This user dosen't have permission to save")
                                } else {
                                    displayAlertMessage('danger', "This user dosen't have permission to edit")
                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to delete !")
                            }
                        } else if (operation == "Print") {
                            if (Print == true) {
                                setprintoptionShow(true)
                            } else {
                                displayAlertMessage('danger', "This user don't have permission to print !")
                            }
                        }
                    }
                    )

            } else if (Response.status == "400") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Oops something went wrong !")

            } else if (Response.status == "403") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "You have not Permission to make changes !")

            } else if (Response.status == "404") {
                setDisabled(false)
                setDisabledCode(false)
                clearPermissionInputs()
                displayAlertMessage('danger', "Password or User Name is Invalid !")

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })
    }


    //Display Alert Function
    function displayAlertMessage(color, message) {
        setAlertColor(color)
        setAlertMsg(message)
        setShow(true)

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    //handle permission alert
    function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
        setPermissionName(LogUserType)
        setReason(reason)
        setPermissionNameDisable(disable)
        setPermissionAlertShow(alertShow)
    }


    //Clear permission name & password
    function clearPermissionInputs() {
        setPermissionName("");
        setPermissionPassword("");
        setReason("");
    }


    //Handle Favourite Button
    const handleFavourite = async () => {
        var response = await addtoFavourite(menuCode, LogUserType);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={() => {
                            setsweetAlertShow(false)
                            if (AlertConfirmOption == 1) {

                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Created", true, true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Updated", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                history.push('/dashboard')
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 6) {
                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Printed", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    handlePermissionAlert(LogUserType, "Deleted", true, true)
                                } else {
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            }

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {
                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                permissions("Save")
                            } else if (AlertConfirmOption == 5) {
                                permissions("Delete")
                            } else if (AlertConfirmOption == 6) {
                                permissions("Print")
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                            clearPermissionInputs()
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={helpUrl != "" ? true : false}
                                        helpClick={() => {
                                            window.open(helpUrl)
                                        }}
                                        //Favorite Button
                                        favoriteEnable={true}
                                        favoriteClick={handleFavourite}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable && isHeadOffice}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button
                                        //Print Button
                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Prnited")
                                            setAlertDescription("Do you wish to Print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        <ReasonTypesMasterContent
                                            GetSelectRow={GetSelectRow}
                                            CodeValue={reasonCode}
                                            CodeonChange={e => {
                                                let val1 = Text(e.target, 5, true, false, "upper", false)
                                                SetCode(val1)
                                            }}
                                            DescValue={reasonDesc}
                                            DescOnChange={e => {
                                                let val2 = Text(e.target, 50, true, false, "any", true
                                                )
                                                SetDescription(val2)
                                            }}
                                            ActiveSw={IsActive}
                                            SwonChange={() => {
                                                SetActive(!IsActive)
                                            }}
                                            transaction={transaction}
                                            TransTypeValue={transType}
                                            TransTypeOnChanage={e => {
                                                SetTransType(e)
                                            }}
                                            DiscountPerceValue={disPercentage}
                                            DiscountPerceOnChange={e => {
                                                var val2 = Numeric(e.target, 5, 2, false)
                                                SetDisPercentage(val2)
                                            }}
                                            DisAmountValue={disAmount}
                                            DisAmountOnChange={e => {
                                                var val3 = Numeric(e.target, 10, 2, false)
                                                SetDisAmount(val3)
                                            }}
                                            DisPerStartValue={disStart}
                                            DisPerStartOnChange={e => {
                                                var val4 = Numeric(e.target, 5, 2, false)
                                                SetDisStart(val4)
                                            }}
                                            DisPerEndValue={disEnd}
                                            DisPerEndOnChange={e => {
                                                var val5 = Numeric(e.target, 5, 2, false)
                                                SetDisEnd(val5)
                                            }}
                                            PermisValue={permission}
                                            PermisOnChange={() => {
                                                SetPermission(!permission)
                                            }}
                                            ReturnValue={rReturn}
                                            ReturnOnChange={() => {
                                                SetRReturn(!rReturn)
                                            }}
                                            CancelValue={rCancel}
                                            CancelOnChange={() => {
                                                SetRCancel(!rCancel)
                                            }}
                                            InstruValue={instruct}
                                            InstruOnChange={() => {
                                                SetInstruct(!instruct)
                                            }}
                                            ManuDisValue={rDiscount}
                                            ManuDisOnChange={(e) => {
                                                SetRDiscount(!rDiscount)
                                                if (rDiscount == true) {
                                                    SetDisEnd(0)
                                                    SetDisStart(0)
                                                    SetDisAmount(0)
                                                    SetDisPercentage(0)
                                                }
                                            }}
                                            NetDisValue={netDis}
                                            NetDisOnChange={() => {
                                                SetNetDis(!netDis)
                                            }}
                                            PosoperationValue={posOperation}
                                            PosoperationOnChange={() => {
                                                SetPosOperation(!posOperation)
                                            }}
                                            modelTrigger={tog_xlarge}
                                            modelOpen={modal_xlarge}
                                            show={show}
                                            disabled={disabled}
                                            disabledCode={disabledCode}
                                            AlertColor={AlertColor}
                                            AlertMsg={AlertMsg}
                                            CodeOnBlur={e => {
                                                getData(e.target.value)
                                            }}
                                            ErrorMsg={ErrorMsg}
                                            menuName={menuName}
                                            percentOnBlur={e => {
                                                var val = DecimalValidation(e.target.value)
                                                if (val == "") {
                                                    SetDisPercentage(0)
                                                } else if (val > 100) {
                                                    SetDisPercentage(0)
                                                } else {
                                                    SetDisPercentage(val)
                                                }
                                            }}
                                            amountOnBlur={e => {
                                                var val = DecimalValidation(e.target.value, 0, true, 2)
                                                if (val == "") {
                                                    SetDisAmount(0)
                                                } else {
                                                    SetDisAmount(val)
                                                }
                                            }}
                                            startonBlur={e => {
                                                var val = DecimalValidation(e.target.value)
                                                if (val == "") {
                                                    SetDisStart(0)
                                                } else if (val > 100) {
                                                    SetDisStart(0)
                                                } else {
                                                    if (disEnd == 0) {
                                                        SetDisStart(val)
                                                    } else if (val > disEnd) {
                                                        SetDisStart(0)
                                                    } else {
                                                        SetDisStart(val)
                                                    }

                                                }
                                            }}
                                            endOnBlur={e => {
                                                var val = DecimalValidation(e.target.value)
                                                if (val == "") {
                                                    SetDisEnd(0)
                                                } else if (val > 100) {
                                                    SetDisEnd(0)
                                                } else {
                                                    if (val >= disStart) {
                                                        SetDisEnd(val)
                                                    } else {
                                                        SetDisEnd(0)
                                                    }

                                                }
                                            }}
                                            onButtonClick={e => {
                                                AutoGenerateCode()
                                                setCodeButton(true)
                                            }}
                                            btnDisable={codeButton}
                                            SearchDisable={searchdisabled}
                                            showFileUpload={(e) => {
                                                const file = e.target.files[0];
                                                readExcel(file);
                                                setvalueUpload(e.target.value)
                                            }}
                                            valueUpload={valueUpload}
                                            menuCode={menuCode}
                                            autoCode={autoCode}
                                            bitSummaryLvl={bitSummaryLvl}
                                            bitDetailLvl={bitDetailLvl}
                                            bitSummaryLvlOnChange={(e) => {
                                                setBitSummaryLvl(e)
                                            }}
                                            bitDetailLvlOnChange={(e) => {
                                                setBitDetailLvl(e)
                                            }}
                                            reqTxnRef1={reqTxnRef1}
                                            reqTxnRef1OnChange={(e) => {
                                                setReqTxnRef1(e)
                                            }}
                                        />
                                    </Row>
                                    <Row>
                                        {crEnable ? (
                                            <DPInfoBox
                                                createdBy={crBy}
                                                createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                                                modifiedBy={mdBy}
                                                modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                                            />
                                        ) : null}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    )

}

export default ReasonTypesMaster